export default __webpack_public_path__ + "static/char-s-12-chs-4ed3c60263a602a0ad6a3c531ff343a1.png";